export default __webpack_public_path__ + "static/media/img3.ed460530.PNG";